var bindsToFinance = { vm: '=' };
var FinanceReportController = (function () {
    function FinanceReportController() {
        this.reportIsLoading = false;
        this.visible = false;
    }
    FinanceReportController.prototype.toggle = function () {
        if (this.visible) {
            this.visible = false;
        }
        else {
            this.visible = true;
        }
    };
    FinanceReportController.prototype.getReport = function () {
        this.reportIsLoading = true;
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        a.setAttribute('href', "/finance");
        a.click();
    };
    return FinanceReportController;
}());
var FinanceReportComponent = (function () {
    function FinanceReportComponent() {
        this.templateUrl = 'report-finance.html';
        this.bindings = bindsToFinance;
        this.controller = FinanceReportController;
    }
    return FinanceReportComponent;
}());
angular
    .module('application')
    .component('reportFinance', new FinanceReportComponent());

//# sourceMappingURL=reporting.finance.component.js.map
